module.exports = __webpack_public_path__ + "img/仓头乡.fd6790cc.png";